export default "__VITE_ASSET__CRWeOS6t__"